import { Box, HStack, Text, useColorModeValue, type BoxProps } from '@chakra-ui/react';

// The Twinden mark, "Home talk": a speech bubble that is also a house, with a
// saffron light in the window. Oxblood on light; lifted on dark. One closed
// path, so the loader can run a dash around it (TwindenLoader, D247).
export const MARK_PATH =
  'M48 10 86 40v32a8 8 0 0 1-8 8H44L28 92V80H18a8 8 0 0 1-8-8V40Z';

interface LogoMarkProps extends BoxProps {
  size?: number;
  /** Fill override, e.g. white on an accent background. */
  color?: string;
  /** The window light; defaults to saffron. */
  light?: string;
}

export function LogoMark({ size = 32, color, light, ...rest }: LogoMarkProps) {
  const fill = useColorModeValue('#7A1F2B', '#B27D84');
  const windowLight = useColorModeValue('#F0B63F', '#1F1D1B');
  const mark = color ?? fill;

  return (
    <Box as="span" display="inline-flex" flexShrink={0} {...rest}>
      <svg width={size} height={size} viewBox="0 0 96 96" role="img" aria-label="Twinden">
        <path
          d={MARK_PATH}
          fill={mark}
          stroke={mark}
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <circle cx="48" cy="52" r="9" fill={light ?? windowLight} />
      </svg>
    </Box>
  );
}

interface LogoProps {
  size?: number;
}

// Mark and wordmark side by side.
export function Logo({ size = 28 }: LogoProps) {
  return (
    <HStack spacing={2} align="center">
      <LogoMark size={size} />
      <Text
        as="span"
        fontFamily="heading"
        fontWeight={800}
        fontSize={`${Math.round(size * 0.85)}px`}
        letterSpacing="-0.03em"
        lineHeight={1}
      >
        twinden
      </Text>
    </HStack>
  );
}
